module.exports = __webpack_public_path__ + "static/media/card_icon_2.f15af794.png";